// Helper for generating verification message body for SMS/email
// Usage: getVerificationMessageBody(to, url, siteName, type)
// type: 'email' | 'phone' (default: 'phone')

function getVerificationMessageBody(to, url, type = 'phone') {
  if (type === 'email') {
    return {
      to,
      subject: "MotoStream Verification Link",
      text: `Hello!\n\nThank you for using MotoStream. Please click the link below to verify your email:\n\n${url}.\n\nBest regards,\nMotoStream Team`,
      html: `<h2>Hello!</h2><p>Thank you for using MotoStream. Please click the link below to verify your email:</p><p><a href="${url}">Click here to verify your email</a></p><p>Best regards,<br>MotoStream Team</p>`
    };
  }
  // Default for phone
  return {
  
    subject: "MotoStream Verification Link",
    text: `Hello!\n\nThank you for using MotoStream. Please click the link below to verify your phone:\n\n${url}.\n\nBest regards,\nMotoStream Team`,
    html: `<h2>Hello!</h2><p>Thank you for using MotoStream. Please click the link below to verify your phone:</p><p><a href="${url}">Click here to verify your phone</a></p><p>Best regards,<br>MotoStream Team</p>`
  };
}

module.exports = { getVerificationMessageBody };
